export default __webpack_public_path__ + "d508258f709520f00e23f43ca802434b.svg";